import { createReducer, on } from '@ngrx/store';

import { ProductViewActions } from './product-view.actions';
import { ProductViewState, initialState } from './product-view.state';

export const reducer = createReducer(
  initialState,
  on(
    ProductViewActions.change_ui_product_sidebar_opened,
    (state, data): ProductViewState => ({
      ...state,
      uiProductSidebarOpened: data.opened
    })
  ),
  on(
    ProductViewActions.change_ui_product_sidebar_right_opened,
    (state, data): ProductViewState => ({
      ...state,
      uiProductSidebarRightOpened: data.opened
    })
  ),
  on(
    ProductViewActions.change_hood_settings_opened,
    (state, data): ProductViewState => ({
      ...state,
      hoodSettingsOpened: data.opened
    })
  ),
  on(ProductViewActions.open_hoodline, (state, data): ProductViewState => {
    let openHoodLines = [...state.openHoodLinePanelIds];
    let hoodSettingsOpened = state.hoodSettingsOpened;

    if (data.closeOthers) {
      openHoodLines = [data.id];
      hoodSettingsOpened = false;
    } else if (!openHoodLines.includes(data.id)) {
      openHoodLines.push(data.id);
    }

    return {
      ...state,
      openHoodLinePanelIds: openHoodLines,
      hoodSettingsOpened: hoodSettingsOpened
    };
  }),
  on(ProductViewActions.close_hoodline, (state, data): ProductViewState => {
    const openHoodLines = state.openHoodLinePanelIds.filter(id => id !== data.id);
    return {
      ...state,
      openHoodLinePanelIds: openHoodLines
    };
  }),
  on(ProductViewActions.toggle_hoodline, (state, data): ProductViewState => {
    let openHoodLines = [...state.openHoodLinePanelIds];
    let hoodSettingsOpened = state.hoodSettingsOpened;

    if (openHoodLines.includes(data.id)) {
      openHoodLines = state.openHoodLinePanelIds.filter(id => id !== data.id);
      return {
        ...state,
        openHoodLinePanelIds: openHoodLines
      };
    } else {
      if (data.closeOthers) {
        openHoodLines = [data.id];
        hoodSettingsOpened = false;
      } else if (!openHoodLines.includes(data.id)) {
        openHoodLines.push(data.id);
      }

      return {
        ...state,
        openHoodLinePanelIds: openHoodLines,
        hoodSettingsOpened: hoodSettingsOpened
      };
    }
  }),
  on(
    ProductViewActions.enable_multi_edit,
    (state): ProductViewState => ({
      ...state,
      multiEditSelectedEntityTypeKey: null,
      multiEditSelectedEntityIds: [],
      multiEditEnabled: true
    })
  ),
  on(
    ProductViewActions.disable_multi_edit,
    (state): ProductViewState => ({
      ...state,
      multiEditSelectedEntityTypeKey: null,
      multiEditSelectedEntityIds: [],
      multiEditEnabled: false
    })
  ),
  on(
    ProductViewActions.toggle_multi_edit,
    (state): ProductViewState => ({
      ...state,
      multiEditSelectedEntityTypeKey: null,
      multiEditSelectedEntityIds: [],
      multiEditEnabled: !state.multiEditEnabled
    })
  ),
  on(
    ProductViewActions.multi_edit_entity_type_selected,
    (state, action): ProductViewState => ({
      ...state,
      multiEditSelectedEntityTypeKey: action.typeKey,
      multiEditSelectedEntityIds: [] // Selection type changed, so we have to clear the currently selected items
    })
  ),
  on(ProductViewActions.multi_edit_entity_selection_changed, (state, action): ProductViewState => {
    const changedEntities = Array.isArray(action.entityId) ? action.entityId : [action.entityId];

    let changedSelection = [...state.multiEditSelectedEntityIds];

    if (action.selected) {
      changedEntities.forEach(selectedEntityId => {
        if (!changedSelection.includes(selectedEntityId)) {
          changedSelection.push(selectedEntityId);
        }
      });
    } else {
      changedSelection = changedSelection.filter(s => !changedEntities.includes(s));
    }

    return {
      ...state,
      multiEditSelectedEntityIds: changedSelection
    };
  }),
  on(
    ProductViewActions.select_multi_edit_entity,
    (state, action): ProductViewState => ({
      ...state,
      multiEditSelectedEntityTypeKey: action.typeKey,
      multiEditSelectedEntityIds: [action.entityId]
    })
  ),
  on(
    ProductViewActions.set_multi_entity_hood_ids,
    (state, action): ProductViewState => ({
      ...state,
      multiEditSelectedHoodIds: action.hoodIds
    })
  ),
  on(
    ProductViewActions.set_overlapping_line_ids,
    (state, action): ProductViewState => ({
      ...state,
      overlappingLineIds: action.lineIds
    })
  )
);
